import { render, staticRenderFns } from "./LatestOrders.vue?vue&type=template&id=bade46a8&"
import script from "./LatestOrders.vue?vue&type=script&lang=ts&"
export * from "./LatestOrders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.10.1_mi7kfaeh4nmupiqclubmvzt3ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconOnFinal: require('/opt/buildhome/repo/components/Icon/OnFinal.vue').default,IconOnProgress: require('/opt/buildhome/repo/components/Icon/OnProgress.vue').default})
